export default "__VITE_ASSET__CIfWtxc$__"